import styled from 'styled-components'
import { Box } from 'vvs-uikit'

export const ModalBanner = styled(Box)<{ background: string }>`
  background-image: url(${({ background }) => background});
  height: 168px;
  width: 100%;
  background-size: cover;
  background-position: center;
`

export const StepDetailBox = styled(Box)`
  ${({ theme }) => theme.mediaQueries.sm} {
    min-height: 192px;
  }
`
